import posthog from 'posthog-js';

const apiKey = process.env.REACT_APP_POSTHOG_API_KEY;

if (apiKey) {
  posthog.init(apiKey, {
    api_host: 'https://eu.i.posthog.com',
    autocapture: false,
    capture_pageview: false,
  });
}

export const identifyUser = (userId: string, properties?: Record<string, any>) => {
  posthog.identify(userId, { ...properties, user_id: userId });
};

export const captureEvent = (eventName: string, properties?: Record<string, any>) => {
  posthog.capture(eventName, properties);
};

export const resetUser = () => {
  posthog.reset();
};

export default { identifyUser, captureEvent, resetUser };
